import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";

const CashDeskPos = () => {
  const { branchId, deskId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [allPoses, setAllPoses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    deskId: deskId,
    title: "",
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [findPosFilterModel, setFindPosFilterModel] = useState({
    branchId: branchId,
    deskId: deskId,
    title: "",
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [selectPosModel, setSelectPosModel] = useState({
    id: 0,
    posDeviceId: 0,
    cashDeskId: deskId,
  });

  const getGridData = async () => {
    const resp = await apiMethod.getDeskPosDevices(
      filterModel.deskId,
      filterModel.title,
      filterModel.size,
      filterModel.part
    );
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  const findAllPoses = async () => {
    const resp1 = await apiMethod.findPosDevices(
      findPosFilterModel.branchId,
      findPosFilterModel.deskId,
      findPosFilterModel.size,
      findPosFilterModel.part,
      findPosFilterModel.title
    );
    if (methods.showApiErrors(resp1)) {
      findPosFilterModel.total = resp1.total;
      findPosFilterModel.parts = methods.calcPageParts(
        resp1.total,
        findPosFilterModel.size
      );
      setFindPosFilterModel({ ...findPosFilterModel });
      setAllPoses(resp1.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId, deskId]);

  const showAllPoses = async () => {
    findAllPoses();
    setShowFormModal(true);
  };

  const selectPos = async (posId) => {
    const updatedModel = { ...selectPosModel, posDeviceId: posId };
    setSelectPosModel(updatedModel);
    await addPosToCashDesk(updatedModel);
  };

  const addPosToCashDesk = async (model) => {
    setLoading(true);
    const resp = await apiMethod.createDeskPos(model);
    if (methods.showApiErrors(resp)) {
      await getGridData();
      setShowFormModal(false);
    }
    setLoading(false);
  };

  const getPosTypeString = (posType) => {
    switch (posType) {
      case 1:
        return "ثابت";
      case 2:
        return "سیار";
      default:
        return "";
    }
  };

  const selectَItemToDelete = (item) => {
    setSelectPosModel({ ...selectPosModel, id: item.id });
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeDeskPos(selectPosModel.id);
      if (!methods.showApiErrors(resp)) return false;
      await getGridData();
      setSelectPosModel({
        id: 0,
        posDeviceId: 0,
        cashDeskId: deskId,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.deskId = deskId;
    filterModel.title = "";
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel });
  };

  const resetFiltersModal = () => {
    findPosFilterModel.branchId = branchId;
    findPosFilterModel.deskId = deskId;
    findPosFilterModel.title = "";
    findPosFilterModel.size = 20;
    findPosFilterModel.part = 1;
    setFilterModel({ ...filterModel });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const searchItemModal = async () => {
    setLoading(true);
    await findAllPoses();
    setLoading(false);
  };

  const clearSearchModal = async () => {
    setLoading(true);
    resetFiltersModal();
    await findAllPoses();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const movePagerPartForModal = (isForward) => {
    if (isForward) {
      if (findPosFilterModel.parts < findPosFilterModel.part + 1) {
        return false;
      }
      callPager(findPosFilterModel.part + 1);
    } else {
      if (findPosFilterModel.part === 1) {
        return false;
      }
      callPager(findPosFilterModel.part - 1);
    }
  };

  const callPagerForModal = async (i) => {
    setLoading(true);
    findPosFilterModel.part = i;
    setFilterModel({ ...findPosFilterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItemsForModal = () => {
    let pages = [];
    for (let i = 1; i <= findPosFilterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            findPosFilterModel.part === i
              ? "page-item active mx-1"
              : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPagerForModal(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/cashDeskManage`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/sale/${branchId}/cashDeskManage`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                صندوق / تخصیص پوز
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>صندوق / تخصیص پوز</p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-12 col-md-6 col-lg-4">
                    <label htmlFor="funit" className="form-label">
                      عنوان
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.title}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            title: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-2 col-lg-4"></div>
                  <div className="col-12 col-md-4 col-lg-4">
                    <div className="createButton">
                      <button
                        onClick={() => {
                          showAllPoses();
                        }}
                        className="btn btn-outline-purple custome-btn"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          تخصیص پوز
                        </span>{" "}
                        <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md ">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">نام صندوق</th>
                      <th scope="col vertical-center">شناسه ترمینال</th>
                      <th scope="col vertical-center">کد</th>
                      <th scope="col vertical-center" width="50px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </th>
                        <td>{item.posTitle}</td>
                        <td>{item.deskTitle}</td>
                        <td>{item.terminalId}</td>
                        <td>{item.code}</td>
                        <td>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="btn btn-sm btn-outline-danger"
                            type="button"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const closeModal = () => {
    setShowFormModal(false);
    setShowDeleteModal(false);
  };

  const Modal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showFormModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">تخصیص پوز </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="col-12 col-md-6">
                <label htmlFor="funit" className="form-label">
                  عنوان
                </label>
                <div className="hstack">
                  <input
                    id="searchInput"
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={findPosFilterModel.title}
                    onChange={(e) => {
                      setFindPosFilterModel({
                        ...findPosFilterModel,
                        title: e.target.value,
                        part: 1,
                      });
                    }}
                  />
                  <button
                    type="button"
                    className="btn btn-purple me-1"
                    onClick={searchItemModal}
                  >
                    <i className="bi bi-search"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-info"
                    onClick={clearSearchModal}
                  >
                    <i className="bi bi-arrow-clockwise"></i>
                  </button>
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md align-middle">
                  <thead className="">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">شناسه ترمینال</th>
                      <th scope="col vertical-center">کد</th>
                      <th scope="col vertical-center">نوع پوز</th>
                      <th scope="col vertical-center" width="50px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {allPoses.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(findPosFilterModel.part - 1) *
                            findPosFilterModel.size +
                            index +
                            1}
                        </th>
                        <td>{item.title}</td>
                        <td>{item.terminalId}</td>
                        <td>{item.code}</td>
                        <td>{getPosTypeString(item.posType)}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-purple"
                            onClick={() => selectPos(item.id)}
                          >
                            افزودن
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {findPosFilterModel.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPartForModal(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItemsForModal()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPartForModal(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeModal}
          deleteItem={deleteItem}
          text={"پوز"}
        />
      )}
    </>
  );
};

export default CashDeskPos;
